module.exports = __webpack_public_path__ + "img/item1-4.d5ec1b30.png";